import React from "react";

export const LOGO_SRC = "/carehr-logo.webp";

// Full CareHR lockup (icon + wordmark + tagline)
export const Logo = ({ size = 44, className = "" }) => {
  return (
    <img
      src={LOGO_SRC}
      alt="CareHR — Healthcare Workforce Network"
      className={className}
      style={{ height: size, width: "auto" }}
    />
  );
};

// Kept for backwards compatibility; renders the same brand lockup.
export const LogoMark = ({ size = 56, className = "" }) => (
  <img
    src={LOGO_SRC}
    alt="CareHR"
    className={className}
    style={{ height: size, width: "auto" }}
  />
);

export default Logo;
